/**
 * 针对 PC MagicBanner
 * 1. 图片宽度位于区间(0,1440），pc前台展示固定宽度1200px；
 * 2. 图片宽度大于等于1440， pc前台按照上传图片实际尺寸展示。
 * eg: 上传宽度为1480px的图片，针对1440屏幕，展示中间1440px，多余部分隐藏。针对1920屏幕，居中展示1480px，两边留白。
 *
 */

import { TBannerItem } from "views/services/banner";

const FixScreenWidth = 1440;
const TightsNormalWidth = 1200;

interface BannerSize {
	gridWidth: string;
	gridHeight?: string;
}

export const getMagicBannerSize = (width: number, aspectRatio: number) => {
	return {
		gridWidth: `${width}px`,
		gridHeight: `${aspectRatio * width}px`,
	};
};

export const getSize = (banner: TBannerItem): BannerSize => {
	const { width = "", height = "" } = banner;
	const aspectRatio = width ? +(+height / +width).toFixed(3) : 0;
	return getMagicBannerSize(+width < FixScreenWidth ? TightsNormalWidth : +width, aspectRatio);
};
